import { render } from "./voters.vue?vue&type=template&id=0175655d"
import script from "./voters.vue?vue&type=script&lang=js"
export * from "./voters.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/cleanshift_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__